export const RECENT_ALERTS_LIMIT = 30
